<template>
  <DefaultProgramsView />
</template>

<script>
import DefaultProgramsView from '@/themes/scsu/DefaultProgramsView'

export default {
  components: {
    DefaultProgramsView,
  },
}
</script>
